import { useTranslation } from 'react-i18next';
import WifiIcon from '@mui/icons-material/Wifi';
import { Typography } from '@mui/material';

import { StyledButton, StyledButtonsWrapper, StyledIconWrapper, StyledMockupWrapper } from './styled';

export const WifiMockup = () => {
  const { t } = useTranslation();

  return (
    <StyledMockupWrapper>
      <StyledIconWrapper>
        <WifiIcon fontSize="70" />
      </StyledIconWrapper>
      <Typography fontSize="16" textAlign="center">
        {t('staticQrTemplates:wifi:mockup:title')}
      </Typography>
      <StyledButtonsWrapper>
        <StyledButton>{t('staticQrTemplates:wifi:mockup:cancel')}</StyledButton>
        <StyledButton>{t('staticQrTemplates:wifi:mockup:accept')}</StyledButton>
      </StyledButtonsWrapper>
    </StyledMockupWrapper>
  );
};
